module.exports = __webpack_public_path__ + "static/media/01-matteoesposito-hover.70b3caff.jpg";